import { defaultTo, get as lodashGet } from 'lodash-es';

type Widen<T> = T extends string
  ? string
  : T extends number
  ? number
  : T extends boolean
  ? boolean
  : T;

/**
 * This function will usually infer the correct type, but you should definitely
 * check to make sure. The rule of thumb is: if the correct type is inferred,
 * don't explicitely specify it; if not then do explicitely specify it.
 * ---
 * Q. Why did we roll our own `get` here instead of using Lodash's directly?
 *
 * A. Lodash's `get` does not have the semantics we want. Lodash's `get` only
 * assigns the default value if applying the path to object results in
 * `undefined`, but we want it to be applied in the case of `null` as well.
 */
export function get<T>(
  object: unknown,
  path: _.Many<string | number | symbol>,
  defaultValue?: Widen<T>
) {
  const value: Widen<T> = lodashGet(object, path);
  return typeof defaultValue === 'undefined'
    ? value
    : defaultTo<Widen<T>>(value, defaultValue);
}
